<template>
  <section class="availability container defaultSectionMargins">
    <h2 v-text="data.title || $t('availability')" />

    <div class="availability__Buttons">
      <div v-for="button in data.cta_buttons">
        <Button type="nuxt-link" :to="`${button.is_email ? link('ContactForm') : `tel: ${button.cta_value || button.cta_text}`}`" secondary class="spaceBetween">
          <template #default>
            {{ button.cta_text }}
          </template>
          <template #append>
            <Icon v-if="button.is_email" name="send-email-large" />
            <Icon v-else name="phone" />
          </template>
        </Button>
        <p v-if="button.note" v-text="button.note" />
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  });

  const { link } = useSetup();
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_availability.scss');
</style>